import { PageLayout } from '@bpm-web-app/components';
import { CrateDetail } from '@bpm-web-app/components/pages';

const CrateCategoryDetailPage = () => (
    <PageLayout>
        <CrateDetail />
    </PageLayout>
);

export default CrateCategoryDetailPage;
